/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { SvgaChecklist } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/degree-home';

const styles: Record<string, Interpolation<Theme>> = {
  emptyStateContainer: () => css`
    text-align: center;
    margin-top: var(--cds-spacing-150);
  `,
  emptyStateIcon: () => css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

export const RecentGradesEmptyState = () => {
  return (
    <Grid
      data-e2e="recent-grades-empty-state"
      id="recent-grades-empty-state"
      item
      alignItems="center"
      xs={12}
      spacing={24}
      css={styles.emptyStateContainer}
    >
      <SvgaChecklist size={28} css={styles.emptyStateIcon} aria-hidden={true} />
      <Typography2 component="h3" variant="subtitleMedium">
        {_t("You're up to date")}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary">
        {_t('You have no more recent grades')}
      </Typography2>
    </Grid>
  );
};

export default RecentGradesEmptyState;
